(function () {
  if (window.stashCardEscapeInit) return;
  window.stashCardEscapeInit = true;

  var DISMISSED = 'is-overlay-dismissed';

  function overlayIsOpen(card) {
    var overlay = card.querySelector('.custom-product-card__hover-content--desktop');
    if (!overlay || getComputedStyle(overlay).display === 'none') return false;
    return card.matches(':hover') || card.matches(':has(:focus-visible)');
  }

  function clearIfIdle() {
    document.querySelectorAll('.custom-product-card.' + DISMISSED).forEach(function (card) {
      if (!card.matches(':hover') && !card.matches(':has(:focus-visible)')) {
        card.classList.remove(DISMISSED);
      }
    });
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') return;

      var cards = new Set();
      var active = document.activeElement;
      var focusCard = active && active.closest && active.closest('.custom-product-card');
      if (focusCard) cards.add(focusCard);
      document.querySelectorAll('.custom-product-card:hover').forEach(function (card) {
        cards.add(card);
      });

      cards.forEach(function (card) {
        if (!overlayIsOpen(card)) return;
        var overlay = card.querySelector('.custom-product-card__hover-content--desktop');
        if (overlay && active && overlay.contains(active)) {
          var mainLink = card.querySelector('.custom-product-card__media > a');
          if (mainLink) mainLink.focus({ preventScroll: true });
        }
        card.classList.add(DISMISSED);
      });
    },
    true
  );

  // Tabbing into the (hidden) controls is a deliberate request to see them again.
  document.addEventListener('focusin', function (event) {
    var card = event.target.closest && event.target.closest('.custom-product-card.' + DISMISSED);
    if (card && event.target.closest('.custom-product-card__hover-content')) {
      card.classList.remove(DISMISSED);
    }
  });

  ['mouseout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function () {
      setTimeout(clearIfIdle, 0);
    });
  });
})();
